import React, { useEffect, useState } from "react";

export default function BannerCarousel() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch("https://ecomapi.asherjewels.com.ph/api/get_banners2.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setBanners(data.data);
        } else {
          console.error("Banner fetch failed:", data.message);
        }
      })
      .catch((err) => console.error("Banner fetch error:", err));
  }, []);

  return (
    <section className="banner-carousel mb-5">
      <div id="goldJewelryCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {banners.map((banner, index) => (
            <div
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              key={banner.id || index}
            >
            <img
              src={banner.imageUrl}
              className="d-block w-100"
              alt={banner.title || "Banner"}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "100vh",
                objectFit: "cover",
              }}
            />

            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#goldJewelryCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#goldJewelryCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
